module.exports = __webpack_public_path__ + "img/gray-card-linear-20x20.62e9fc3a.svg";